export { Tabs } from './Tabs'
export type { TabsProps, TabsTabProps } from './Tabs.types'
